"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDocumentTitles = mapDocumentTitles;
exports.mapCommunicationTitles = mapCommunicationTitles;
var SEARCH_VALUE = "wolf";
var REPLACE_VALUE = "allianz_online";
function normalizeName(name) {
    return name.replace(SEARCH_VALUE, REPLACE_VALUE);
}
function mapDocumentTitles(documents) {
    return documents.map(function (document) {
        var replacedName = normalizeName(document.name);
        return __assign(__assign({}, document), { title: replacedName, downloadName: replacedName, name: replacedName, date: document.date });
    });
}
function mapCommunicationTitles(communications) {
    return communications.map(function (communication) {
        var replacedName = normalizeName(communication.subject);
        return __assign(__assign({}, communication), { subject: replacedName });
    });
}
//# sourceMappingURL=DataMappers.js.map